import {
  Icon3DLine,
  IconBinocularsGray,
  IconBuildings,
  IconCctvLine,
  IconChainLink,
  IconClockGray,
  IconCloud,
  IconGlobal,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconShare,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';

import image1 from '@src/assets/images/digitaltwin/image/image1.avif';
import image2 from '@src/assets/images/digitaltwin/image/image2.avif';

import gis from '@src/assets/images/digitaltwin/video/gis.mp4';
import weather from '@src/assets/images/digitaltwin/video/weather.mp4';
import buildings from '@src/assets/images/digitaltwin/video/buildings.mp4';
import tracking from '@src/assets/images/digitaltwin/video/tracking.mp4';
import traffic from '@src/assets/images/digitaltwin/video/traffic.mp4';
import airplane from '@src/assets/images/digitaltwin/video/airplane.mp4';
import cctv from '@src/assets/images/digitaltwin/video/cctv.mp4';

export default {
  type: '都市ソリューション',

  banner: {
    title: '都市インフラをデジタルツインで効率的に管理しましょう。',
    desc: '都市のインフラ状況と運用状況をデジタルツイン技術でリアルタイムにモニタリングし、効率的に管理することで、運用の安定性と効率性を高めます。',
  },

  video: {
    title: 'デジタルツイン技術で都市のインフラ状況を一目で把握。',
    desc: 'デジタルツイン技術を活用し、都市内の主要インフラの状態と運用データをリアルタイムに統合・可視化することで、体系的で効率的な管理を実現します。',
    image: image1,
  },

  func: [
    {
      theme: 'デジタルツインで都市インフラの現状をリアルタイムに確認・管理。',
      title: 'リアルタイム3Dビジュアルデータ提供',
      desc: '都市内の建物や内部施設を正確な3Dモデルで再現し、リアルタイム情報を直感的に確認できます。施設の運用状況や状態を迅速に把握し、効率的な運用を支援します。',
      sub1: '高精度データ提供',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      video: gis,
    },
    {
      title: '気象情報リアルタイム連携',
      desc: '現実の天気データをシステムにリアルタイムで連携し、雨や雪などの気象状況を現実と同じように再現。より没入感のある正確な運用対応が可能です。',
      sub2: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub1: '迅速なデータ連携',
      icon2: IconTvocGray,
      video: weather,
    },
    {
      title: '建物情報リアルタイム管理',
      desc: '施設状態やメンテナンススケジュールをリアルタイムでモニタリングし、センサーデータで機器故障やエネルギー消費を予測。効率的な運用と環境配慮型管理を支援します。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度データ提供',
      icon2: IconRulerGray,
      video: buildings,
    },
    {
      title: '屋内施設リアルタイムマップ構築',
      desc: '屋内の物品や移動中の人の情報をリアルタイムに反映し、人流とセキュリティ状況を正確に把握。迅速な運用管理とセキュリティ対応をサポートします。',
      sub1: '柔軟な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      video: tracking,
    },
    {
      theme: '都市全体の移動・安全情報を統合し、効率的な運営を実現。',
      title: '人と車両の移動情報をリアルタイム管理',
      desc: '都市内の車両や人の移動情報をリアルタイムに分析し、交通渋滞を防止。事故発生時も即座に対応し、迅速かつ正確な都市運営を支援します。',
      sub1: '柔軟な範囲設定',
      icon2: IconZoneGray,
      sub2: '複数エリア設定',
      icon1: IconTagGray,
      image: image2,
    },
    {
      title: '公共交通機関リアルタイム情報連携',
      desc: 'バスや地下鉄などの公共交通のリアルタイム運行情報を提供し、最適ルートを案内。交通渋滞を最小化し、都市の交通効率を大幅に向上させます。',
      sub1: '高精度データ提供',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      video: traffic,
    },
    {
      title: '航空機運行情報リアルタイム連携',
      desc: '航空機のリアルタイム運行情報をシステムと連携し、遅延や変更を即時に通知。移動のスムーズ化と運用効率の向上を支援します。',
      sub1: '迅速な設置完了',
      icon1: IconTagGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      video: airplane,
    },
    {
      title: 'CCTV映像リアルタイムモニタリング管理',
      desc: '都市内のCCTV映像をリアルタイムで接続し、異常を即時検知。犯罪防止や交通状況の迅速な管理を通じて、都市の安全を効果的に守ります。',
      sub1: 'リアルタイムビジュアル化',
      icon1: IconShareGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      video: cctv,
    },
  ],

  subfunc: {
    title: '主要機能概要',
    desc: '',

    data: [
      {
        icon: Icon3DLine,
        title: 'リアルタイム3Dビジュアル化',
        desc: '都市施設のリアルタイム3D再現とモニタリングを支援',
      },
      {
        icon: IconCloud,
        title: 'リアルタイム気象情報連携',
        desc: '現実の天候データをリアルタイムでシステムと連携',
      },
      {
        icon: IconBuildings,
        title: '建物情報確認',
        desc: '建物設備の状態とエネルギー消費をリアルタイムで管理',
      },
      {
        icon: IconRoom,
        title: '屋内リアルタイムマップ構築',
        desc: '屋内物品と人の位置をリアルタイムでマップ化',
      },
      {
        icon: IconRoute,
        title: '人と車両の移動分析',
        desc: '車両と人のリアルタイム移動データを分析し対応',
      },
      {
        icon: IconChainLink,
        title: '公共交通情報連携',
        desc: 'バス・地下鉄などのリアルタイム位置情報を提供',
      },
      {
        icon: IconShare,
        title: '航空機情報リアルタイム連携',
        desc: '航空機の運行情報をリアルタイムでシステムと連携',
      },
      {
        icon: IconCctvLine,
        title: 'CCTVリアルタイムモニタリング',
        desc: 'CCTV映像をリアルタイムで分析し都市の安全を管理',
      },
      {
        icon: IconGlobal,
        title: '地理情報プラットフォーム連携',
        desc: 'GISデータと連携して空間情報を効率的に管理',
      },
      {
        icon: IconChainLink,
        title: '外部システムAPI連携',
        desc: '多様なシステムデータを柔軟に統合サポート',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
